import { ReservationTimeSchema } from './reservation-time-new-form-schema'
import { ReservationTimeNewFormData } from './reservation-time-new-form.types'

type reservationTimeNewAsFormDataParams = {
  tenantId: string
  propertyId: string
  resourceTypeId: string
  data: ReservationTimeSchema
  originId: string
  confirmedStateId: string
  chargeCategoryId: string
  rateId: string
  resourceId?: string
}

export const reservationTimeNewAsFormData = ({
  tenantId,
  propertyId,
  resourceTypeId,
  data,
  originId,
  confirmedStateId,
  chargeCategoryId,
  rateId,
}: reservationTimeNewAsFormDataParams): ReservationTimeNewFormData => {
  return {
    tenantId,
    propertyId: [propertyId],
    isGroup: false,
    notes: data.notes ? [{ type: 'RESERVATION', description: data.notes }] : null,
    originId,
    reference: {
      mainGuestId: data.customerPersonId,
      customerCompanyId: data.customerCompanyId,
      customerPersonId: data.customerPersonId,
    },
    reservationStateId: confirmedStateId,
    reservedResources: data.resourceIds.map((rId) => ({
      adults: 0,
      children: 0,
      time: AdjustActivityTime({ from: data.reservationTime.start, to: data.reservationTime.end }),
      resourceOccupancies: [
        {
          start: data.reservationDate.checkIn,
          end: data.reservationDate.checkOut,
          resourceTypeId: resourceTypeId,
          resourceId: rId,
        },
      ],
      chargeCategoryId,
      childOccupancies: null,
      rateId,
      manualPrice: data.manualPrice,
    })),
  }
}

/** When `from` and `to` are at midnight **(00:00)** return an adjusted activity time from **00:00** to **23:59** */
export const AdjustActivityTime = (range: { from: Date; to: Date }) => {
  const { from, to } = range
  const fromH = from.getHours()
  const fromM = from.getMinutes()
  const toH = to.getHours()
  const toM = to.getMinutes()
  if (fromH === 0 && fromM === 0 && fromH === toH && fromM === toM) {
    return { from, to: new Date(1970, 0, 1, 23, 59) }
  }
  return range
}
